import styled, { css } from 'styled-components'

type TextareaProps = {
  hasText?: boolean
}

export const Textarea = styled.textarea<TextareaProps>`
  background: transparent;
  min-height: 3.125rem;
  resize: none;
  outline: none;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:read-only {
    opacity: 0.5;
  }

  ${({ hasText }) =>
    hasText &&
    css`
      text-overflow: clip;
      white-space: normal;
    `}
`

Textarea.displayName = 'Textarea'
